export default __webpack_public_path__ + "static/media/CharlesSchwab.599dbdf0.svg";